import type { Common } from "./ios";

import { EMPTY } from "~/shared/str";

function mapDtoToEntity({
  name,
  description,

  ...rest
}: Common.OutSchema) {
  return {
    ...rest,
    name: name ?? EMPTY,
    description: description ?? EMPTY,
  };
}

export { mapDtoToEntity };
